import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InvoiceCard = ({ invoice, onDownload, onView }) => {
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })?.format(new Date(date));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'paid':
        return 'bg-success/10 text-success';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'overdue':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="p-4 bg-card border border-border rounded-lg hover:shadow-elevation-1 transition-smooth">
      <div className="flex items-start justify-between gap-4 mb-3">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="FileText" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">{invoice?.number}</h3>
            <p className="text-sm text-muted-foreground">{invoice?.description}</p>
          </div>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getStatusColor(invoice?.status)}`}>
          {invoice?.status === 'paid' ? 'Ödendi' :
           invoice?.status === 'pending' ? 'Beklemede' :
           invoice?.status === 'overdue' ? 'Gecikmiş' : invoice?.status}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 py-3 border-t border-border">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Tutar</p>
          <p className="text-lg font-bold text-foreground">{formatAmount(invoice?.amount)}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Tarih</p>
          <p className="text-sm font-medium text-foreground">{formatDate(invoice?.date)}</p>
        </div>
      </div>
      {invoice?.dueDate && (
        <div className="py-2 border-t border-border">
          <p className="text-xs text-muted-foreground mb-1">Son Ödeme Tarihi</p>
          <p className="text-sm font-medium text-foreground">{formatDate(invoice?.dueDate)}</p>
        </div>
      )}
      <div className="flex gap-2 pt-3 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          iconName="Eye"
          iconPosition="left"
          onClick={() => onView(invoice)}
          className="flex-1"
        >
          Görüntüle
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="Download"
          iconPosition="left"
          onClick={() => onDownload(invoice)}
          className="flex-1"
        >
          İndir
        </Button>
      </div>
    </div>
  );
};

export default InvoiceCard;